import styled, { css } from 'styled-components'
import { StyledButtonGroupProps } from './ButtonGroup.types'

const variantStyles = {
  action: css`
    display: inline-flex;
    gap: 6px;
    flex-wrap: wrap;
  `,
  header: css`
    display: inline-flex;
    gap: ${({ theme }) => theme.spacing.medium};

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
      width: 100%;

      & > button {
        flex: 1;
        justify-content: center;
      }
    }
  `,
  property: css`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.medium};
    flex-wrap: wrap;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      flex-wrap: nowrap;

      /* Hide scrollbar but keep functionality */
      scrollbar-width: none;
      -ms-overflow-style: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  `,
}

export const StyledButtonGroup = styled.div<StyledButtonGroupProps>`
  ${(props) => variantStyles[props.$variant]}
`

export const ActionGroup = styled(StyledButtonGroup).attrs({
  $variant: 'action' as const,
})`
  /* Action group specific overrides if needed */
`

export const HeaderActions = styled(StyledButtonGroup).attrs({
  $variant: 'header' as const,
})`
  /* Header actions specific overrides if needed */
`

export const PropertyActions = styled(StyledButtonGroup).attrs({
  $variant: 'property' as const,
})`
  /* Property actions specific overrides if needed */

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    /* Ensure action groups inside don't wrap on mobile */
    ${ActionGroup} {
      flex-shrink: 0;
      flex-wrap: nowrap;
    }
  }
`
